import { Pipe, PipeTransform } from '@angular/core';

import { convertUTCtoTimezone } from '@utils/date-converter';
import { ITimeZoneModel } from '../../../model/common.model';
import {TimezoneInterface} from '@interfaces/timezone/timezone.interface';

@Pipe({
  name: 'convertDate',
  standalone: true,
})
export class ConvertDatePipe implements PipeTransform {
  transform(date: string, dateType: TimezoneInterface): Date {
    return convertUTCtoTimezone(date, dateType.utcOffset * 60);
  }
}
